import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import "../SignupPages/SignupCommon.css";

const NadPlusPage5: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const navigate = useNavigate();
  const location = window.location.pathname;
  const isSermorelinPage = location.includes("sermorelin");

  const options = ["Yes", "No"];

  useEffect(() => {
    const step4Completed = localStorage.getItem("completed-step-4");
    if(isSermorelinPage){
      if (step4Completed) {
        navigate("/sermorelin/getting-started/step-5", { replace: true });
      } else {
        navigate("/sermorelin/getting-started/step-4", { replace: true });
      }
    }else{
      if (step4Completed) {
        navigate("/nadplus/getting-started/step-5", { replace: true });
      } else {
        navigate("/nadplus/getting-started/step-4", { replace: true });
      }
    }
  }, []);

  useEffect(() => {
    const savedHistory = localStorage.getItem(
      "Do_you_have_a_history_of_active_suspected_or_prior_cancer_of_any_kind"
    );
    if (savedHistory) {
      const parsed = JSON.parse(savedHistory);
      setSelectedOption(parsed.value);
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
    localStorage.setItem(
      "Do_you_have_a_history_of_active_suspected_or_prior_cancer_of_any_kind",
      JSON.stringify({
        key: "Do_you_have_a_history_of_active_suspected_or_prior_cancer_of_any_kind",
        value: option,
      })
    );

    localStorage.setItem("completed-step-5", "true");

    if(isSermorelinPage){
      if (option === "Yes") {
        setTimeout(() => {
          navigate("/sermorelin/disqualified");
        }, 1000);
        
      } else {
        setTimeout(() => {
          navigate("/sermorelin/getting-started/step-6");
        }, 1000);  
      }
    }else{
      if (option === "Yes") {
        setTimeout(() => {
          navigate("/nadplus/disqualified");
        }, 1000);

      } else {
        setTimeout(() => {
          navigate("/nadplus/getting-started/step-6");
        }, 1000);

      }
    }
  };

  const handleBack = () => {
    if(isSermorelinPage){
      navigate("/sermorelin/getting-started/step-4");
    }else{
      navigate("/nadplus/getting-started/step-4");
    }
   
  };

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={50} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-intro">
            Do you have a history of active, suspected, or prior cancer of any kind?
          </p>
          <div className="options options-box">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NadPlusPage5;